/*
 * @Author: your name
 * @Date: 2021-03-30 10:30:04
 * @LastEditTime: 2021-05-10 14:55:54
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \zlt-front-end\src\TASMini\api\common.js
 */
import request from '../../utils/request'

//登录
export function loginRequest(data) {
    return request({
        url: '/auth/account/login',
        method: 'post',
        data
    })
}

//是否可以登陆
export function getIsLongi(data) {
    return request({
        url: '/auth/account/getIsLongi',
        method: 'get',
        
    })
}

//退出登录
export function logoutRequest(query) {
    return request({
        url: '/auth/account/logout',
        method: 'get',
        params: query
    })
}

//上传图片
export function uploadImg(data) {
    return request({
        url: '/external/uploadFile',
        method: 'post',
        data
    })
}
// 菜单
export function queryMenusByToken(params) {
    return request({
        url: '/auth/menus/queryMenusByToken',
        method: 'get',
        params
    })
}

//查询所有基础区域
export function queryAllBaseArea() {
    return request({
        url: '/resource/basicDomesticArea/queryAllBaseArea',
        method: 'get',
    })
}

//登陆成功必调接口
export function initSettingBycurrUser() {
    return request({
        url: '/setting/eshop/init/initSettingBycurrUser',
        method: 'get',
    })
}

//根据区县名称查询地区编码
// /setting/wxpay/apply/queryAddressCode
export function queryAddressCode(params) {
    return request({
        url: '/setting/wxpay/apply/queryAddressCode',
        method: 'get',
        params
    })
}



// WEBPACK FOOTER //
// ./src/TASMini/api/common.js